module.exports = __webpack_public_path__ + "static/media/logo_logistica_novo_mini.cfc65a0e.png";